import logo from './logo.svg';
import './App.css';
import Portfolio from './component/Portfolio';
import AnimatedHeader from './Animation/AnimatedHeader';
import Footer from './component/Footer';
import Nav from "./component/Nav"
import Skill from './component/skill';
function App() {
  return (
    <div className="App">
    <Nav/>
      <AnimatedHeader/>
      <Skill></Skill>
      <Portfolio/>
      <Footer/>
    </div>
  );
}

export default App;
